"use client";
import { getGTMId } from "@/utils/gtm";
import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { getSiteDomain } from "@/utils/site";
import { scheduleIdle } from "@/utils/browser";
import { isStripeCriticalPath } from "@/internals/constants/paths";

export const GoogleTagManagerInitiator = () => {
  const siteDomain = getSiteDomain();
  const gtmId = getGTMId(siteDomain);
  const pathname = usePathname();
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    // Only defer GTM on Stripe-critical routes (/pricing, /payment) so it
    // doesn't compete with the ECE boot. Everywhere else GTM must fire
    // immediately so marketing attribution + pageviews aren't lost on fast
    // bounces
    if (!isStripeCriticalPath(pathname)) {
      setShouldLoad(true);
      return;
    }
    const cancel = scheduleIdle(() => setShouldLoad(true), 3000);
    return cancel;
  }, [pathname]);

  useEffect(() => {
    if (!gtmId || !shouldLoad) {
      return;
    }
    if (document.getElementById("gtm-script")) return;

    const script = document.createElement("script");
    script.id = "gtm-script";
    script.innerHTML = `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');
`;
    document.head.appendChild(script);
  }, [gtmId, shouldLoad]);

  return null;
};
